angular.module("warsApp").config(['$routeProvider', function ($routeProvider) {

    var ensureUserIsAuthenticated = {
        auth: [
            "$q", "authService", "$location", "$rootScope", function ($q, authService, $location, $rootScope) {
                if (authService.authentication.isAuth) {
                    return $q.resolve({ authenticated: true });
                } else {
                    var url = $location.url();
                    localStorage.setItem('redirectAfterLogin', url.toString());
                    $rootScope.$broadcast("userNotAuthorized");
                    return $q.reject({ authenticated: false });
                }
            }
        ]
    };

    $routeProvider.when('/home',
        {
            templateUrl: './app/views/home.html'
        })
        .when('/Error',
        {
            templateUrl: './app/views/customError.html'
        })
        .when('/ManageSystemCodes',
        {
            templateUrl: './app/views/configuration/manageSystemCodes.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageGisDatastores',
        {
            templateUrl: './app/views/gisDatastore.html',
            controller: 'gisDatastoreController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageApiKeys',
        {
            templateUrl: './app/views/configuration/ApiKey.html',
            controller: 'apiKeyController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageScheduledResources',
        {
            templateUrl: './app/views/configuration/manageScheduledResources.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageUsers',
        {
            templateUrl: './app/views/manageUsers.html',
            controller: 'manageUsersController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageConstants',
        {
            templateUrl: './app/views/configuration/constantConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageCalculations',
        {
            templateUrl: './app/views/configuration/calculationConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageDocuments',
        {
            templateUrl: './app/views/configuration/systemDocumentConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageDocumentConfigurations',
        {
            templateUrl: './app/views/configuration/documentConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManagePayments',
        {
            templateUrl: './app/views/configuration/paymentConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageSystemVariables',
        {
            templateUrl: './app/views/configuration/processData.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageHolidays',
        {
            templateUrl: './app/views/holidaySetConfiguration.html',
            controller: 'holidaySetConfigurationController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/MapConfigurations',
        {
            templateUrl: './app/views/configuration/gis/mapConfigurations.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/MapConfiguration/:mapConfigurationId',
        {
            templateUrl: './app/views/configuration/gis/mapConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageHeaderFooter',
        {
            templateUrl: './app/views/headerFooterConfiguration.html',
            controller: 'headerFooterConfigurationController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageClaims',
        {
            templateUrl: './app/views/manageClaims.html',
            controller: 'manageClaimsController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageDataSources',
        {
            templateUrl: './app/views/dataSourceConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/Unauthorized',
        {
            templateUrl: './app/views/notAuthorized.html'
        })
        .when('/NotFound',
        {
            templateUrl: './app/views/notFound.html'
        })
        .when('/ManageSecurityMatrix',
        {
            templateUrl: './app/views/manageSecurityMatrix.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ProcessSecurity',
        {
            templateUrl: './app/views/processSecurity.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageEmailGroups',
        {
            templateUrl: './app/views/manageEmailGroups.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageForm/:subId',
        {
            templateUrl: './app/views/configuration/process/formConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageForms',
        {
            templateUrl: './app/views/configuration/process/processFormsConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageWebPage/:id',
        {
            templateUrl: './app/views/editableWebPage.html',
            controller: 'editableWebPageController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/JsonDictionaryStores',
        {
            templateUrl: './app/views/jsonDictionaryStores.html',
            controller: 'jsonDictionaryStoresController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ProcessConfiguration/:id/Manage',
        {
            templateUrl: './app/views/configuration/configuration.html',
            controller: 'configurationController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ProcessConfiguration/:id/Manage/:section',
        {
            templateUrl: './app/views/configuration/configuration.html',
            controller: 'configurationController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ProcessConfiguration/:id/Manage/:section/:subId',
        {
            templateUrl: './app/views/configuration/configuration.html',
            controller: 'configurationController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageContent',
        {
            templateUrl: './app/views/contentManagement/contentManagement.html',
            controller: 'manageContentController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageQueries',
        {
            templateUrl: './app/views/queryConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageReviewGroups',
        {
            templateUrl: './app/views/configuration/manageReviewGroups.html',
            controller: 'manageReviewGroupsController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageProcessSubTypeGroups',
        {
            templateUrl: './app/views/configuration/manageSubTypeGroups.html',
            controller: 'manageSubTypeGroupsController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageSystemActions',
        {
            templateUrl: './app/views/configuration/manageSystemActions.html',
            controller: 'manageSystemActionsController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageProcessEvents',
        {
            templateUrl: './app/views/configuration/manageProcessEvent.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageFormContainerAssociations',
        {
            templateUrl: './app/views/configuration/manageFormContainerAssociations.html',
            controller: 'manageFormContainerAssociationsController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageTimePeriods',
        {
            templateUrl: './app/views/configuration/timePeriodConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageClaimGroups',
        {
            templateUrl: './app/views/configuration/manageClaimGroups.html',
            controller: 'manageClaimGroupsController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageStaticDocuments', {
            templateUrl: './app/views/manageStaticDocuments.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageStatuses', {
            templateUrl: './app/views/configuration/manageStatuses.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ApiConfiguration', {
            templateUrl: './app/views/configuration/apiConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageEmailNotifications', {
            templateUrl: './app/views/configuration/process/emailSystemActionConfiguration.html',
            //controller: 'emailSystemActionConfigurationController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ManageBatchJobs', {
            templateUrl: './app/views/configuration/batchJobConfiguration.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/NotificationSubscriptions', {
            templateUrl: './app/views/notificationSubscriptions.html',
            controller: 'notificationSubscriptionsController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/EmailNotification', {
            templateUrl: './app/views/emailNotification.html',
            controller: 'emailNotificationController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/UserAdministration', {
            templateUrl: './app/views/userAdministration.html',
            controller: 'userAdministrationController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/BatchJobDashboard', {
            templateUrl: './app/views/batchJobDashboard.html',
            controller: 'batchJobDashboardController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ProcessTypes', {
            templateUrl: './app/views/activeProcesses.html',
            controller: 'activeProcessTypesController'
        })
        .when('/ManageProcessTypes', {
            templateUrl: './app/views/processType.html',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ExtensibleComponents', {
            templateUrl: './app/views/manageExtensibleComponents.html',
            controller: 'manageExtensibleComponentController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ProcessType/:id/Process/:processId', {
            templateUrl: './app/views/process/process.html',
            controller: 'processController'
        })
        .when('/Process/:processId', {
            templateUrl: './app/views/process/process.html',
            controller: 'processController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/Process/:processId/Form/:formContainerUniqueId', {
            templateUrl: './app/views/process/process.html',
            controller: 'processController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ProcessType/:id/Process/:processId/Form/:formContainerUniqueId', {
            templateUrl: './app/views/process/process.html',
            controller: 'processController'
        })
        .when('/ProcessType/:id/ReportProcess/:processId', {
            templateUrl: './app/views/process/reportProcess.html',
            controller: 'reportProcessController'
        })
        .when('/ProcessType/:id/Process/:processId/Form/:formId/FormData/:formDataId', {
            templateUrl: './app/views/process/process.html',
            controller: 'processController'
        })
        .when('/ProcessType/:id/Process/:processId/Form/:formId/FormData/:formDataId/ParentForm/:parentFormId/ParentFormDataId/:parentFormDataId/:parentFormName', {
            templateUrl: './app/views/process/process.html',
            controller: 'processController'
        })
        .when('/ProcessType/:id/Process', {
            templateUrl: './app/views/process/process.html',
            controller: 'processController'
        })
        .when('/ProcessType/:id/ReportProcess', {
            templateUrl: './app/views/process/reportProcess.html',
            controller: 'reportProcessController'
        })
        .when('/ManageObjectQueries', {
            templateUrl: './app/views/objectQuery.html',
            //controller: 'objectQueryController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/Documentation/:id', {
            templateUrl: './app/views/documentation.html',
            controller: 'documentationController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/Documentation/:id/:anchor', {
            templateUrl: './app/views/documentation.html',
            controller: 'documentationController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ContentPage/:id', {
            templateUrl: './app/views/contentPage.html',
            controller: 'contentPageController'
        })
        .when('/ActivateSystemConfiguration', {
            templateUrl: './app/views/activateSystemConfiguration.html',
            controller: 'activateSystemConfigurationController'
        })
        .when('/InitiatePayment', {
            templateUrl: './app/views/paymentWindow.html',
            controller: 'paymentWindowController'
        })
        .when('/help', {
            templateUrl: './app/views/help.html',
        })
        .when('/test', {
            templateUrl: './app/test/views/test.html',
            controller: 'testController'
        })
        .when('/test/memory', {
            templateUrl: './app/test/views/testMemory.html',
            controller: 'testMemoryController'
        })
        .when('/test/autoVersionAndActivate', {
            templateUrl: './app/test/views/testAutoVersionAndActivate.html',
            controller: 'testAutoVersionAndActivateController'
        })
        .when('/test/processEvent', {
            templateUrl: './app/test/views/testProcessEvent.html',
            controller: 'testProcessEventController'
        })
        .when("/login", {
            controller: "loginController",
            templateUrl: "./app/security/views/login.html"
        })
        .when("/signup", {
            controller: "signupController",
            templateUrl: "./app/views/signup.html"
        })
        .when("/tokens", {
            controller: "tokensManagerController",
            templateUrl: "./app/security/views/tokens.html"
        })
        .when("/associate", {
            controller: "associateController",
            templateUrl: "./app/security/views/associate.html"
        })
        .when("/cleanDatabase", {
            controller: "cleanDatabaseController",
            templateUrl: "./app/views/test/cleanDatabase.html"
        })
        .when('/Impersonate', {
            templateUrl: './app/views/impersonate.html',
            controller: 'impersonationController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/ChangeSystemTime', {
            templateUrl: './app/views/changeSystemTime.html',
            controller: 'changeSystemTimeController',
            resolve: ensureUserIsAuthenticated
        })
        .when('/', {
            redirectTo: '/home'
        })
        .otherwise({
            redirectTo: '/NotFound'
        });
}]);
// Required because our ng-view is contained within a ng-include (for layout.html) this is required otherwise 
// the $route initialization is delayed and will miss the location change event. 
angular.module("warsApp").run(['$route', function ($route) {
    $route.reload();
}]);

angular.module("warsApp").run(['authService', function (authService) {
    authService.fillAuthData();
}]);


angular.module("warsApp").run(["$rootScope", "$location", 'authService', function ($rootScope, $location, authService) {
    $rootScope.$on("$routeChangeError", function (event, current, previous, eventObj) {
        if (eventObj.authenticated === false) {
            authService.redirectUrl = $location.$$path;
            $location.path("/login");
        }
    });
}]);